<template>
  <div>
    <table width="300px" class="table font-oswald">
      <tbody>
        <tr>
          <td class="subtable" width="150px">TRANSACCIONES</td>
          <td class="subtable b text-right">{{ totalventas }}</td>
        </tr>
        <tr>
          <td class="subtable">TOTAL CANTIDAD</td>
          <td class="subtable b text-right">{{ fcantidad }}</td>
        </tr>
        <tr>
          <td class="subtable">TOTAL IMPUESTOS</td>
          <td class="subtable b text-right">{{ ftotalimpuestos }}</td>
        </tr>
        <tr>
          <td class="subtable">TOTAL VENTAS</td>
          <td class="subtable b text-right">{{ ftotales }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    totalventas: { type: Number, default: 0 },
    fcantidad: { type: String, default: "0" },
    ftotalimpuestos: { type: String, default: "$ 0" },
    ftotales: { type: String, default: "$ 0" }
  }
};
</script>